import {AfterViewInit, Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';

import {Team, TeamHal} from '../../models/HAL/team-hal.model';
import {SessionService} from '../../services/session.service';
import {Session} from '../../models/session.model';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';
import {TenantSpecificAssetPipe} from '../../pipes/tenant-specific-asset.pipe';
import {TeamCardComponent} from '../../components/team-card/team-card.component';

@Component({
  selector: 'app-team-selection',
  imports: [
    TranslatePipe,
    TenantSpecificAssetPipe,
    TeamCardComponent
  ],
  templateUrl: './team-selection.component.html',
  styleUrl: './team-selection.component.scss'
})
export class TeamSelectionComponent implements AfterViewInit {
  teams: Team[] | undefined = undefined;
  session: Session = {};

  constructor(
    activatedRoute: ActivatedRoute,
    private readonly loadingSpinnerService: LoadingSpinnerService,
    private readonly sessionService: SessionService,
    private readonly router: Router
  ) {
    this.loadingSpinnerService.show();
    const teamHal: TeamHal = new TeamHal(activatedRoute.snapshot.data['team']);
    this.session = sessionService.getSession();
    this.teams = teamHal._embedded?.teams?.slice().sort((first, second) => first.name.localeCompare(second.name));
    this.session.teams = this.teams;
    sessionService.setSession(this.session);
  }

  ngAfterViewInit() {
    this.loadingSpinnerService.hide();
  }

  public changeTeam(chosenTeam: Team) {
    this.loadingSpinnerService.show();
    this.session.currentTeam = chosenTeam;
    this.session.teams = this.teams;
    this.sessionService.setSession(this.session);
    this.router.navigate([chosenTeam._links.getLink('caseOverview')!.getRoute()]).then();
  }
}
